import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, UsersIcon, XIcon } from 'lucide-react';
import * as XLSX from 'xlsx';
interface Registration {
  id: number;
  nombre: string;
  email: string;
  fecha: string;
}
interface AdminPanelProps {
  isOpen: boolean;
  onClose: () => void;
}
export const AdminPanel: React.FC<AdminPanelProps> = ({
  isOpen,
  onClose
}) => {
  const [registrations, setRegistrations] = useState<Registration[]>([]);
  useEffect(() => {
    if (isOpen) {
      loadRegistrations();
    }
  }, [isOpen]);
  const loadRegistrations = () => {
    const data = JSON.parse(localStorage.getItem('registrations') || '[]');
    setRegistrations(data);
  };
  const exportToExcel = () => {
    const dataForExport = registrations.map(reg => ({
      Nombre: reg.nombre,
      Email: reg.email,
      'Fecha de Registro': new Date(reg.fecha).toLocaleString('es-ES')
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataForExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Registros');
    const fileName = `registros_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };
  const clearAllRegistrations = () => {
    if (window.confirm('¿Estás seguro de que quieres eliminar todos los registros?')) {
      localStorage.removeItem('registrations');
      setRegistrations([]);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-53">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.9
    }} className="bg-gray-900 rounded-xl border border-gray-800 w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-54">
        <div className="p-6 border-b border-gray-800 flex items-center justify-between" data-id="element-55">
          <div className="flex items-center gap-3" data-id="element-56">
            <UsersIcon className="text-purple-400" size={24} data-id="element-57" />
            <h2 className="text-2xl font-bold" data-id="element-58">Panel de Administración</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-59">
            <XIcon size={24} data-id="element-60" />
          </button>
        </div>
        <div className="p-6 flex-1 overflow-y-auto" data-id="element-61">
          <div className="flex items-center justify-between mb-6" data-id="element-62">
            <div className="text-sm text-gray-400" data-id="element-63">
              Total de registros:{' '}
              <span className="text-white font-bold" data-id="element-64">
                {registrations.length}
              </span>
            </div>
            <div className="flex gap-3" data-id="element-65">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={exportToExcel} disabled={registrations.length === 0} className="px-4 py-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-700 disabled:cursor-not-allowed rounded-lg font-medium flex items-center gap-2 transition-colors" data-id="element-66">
                <DownloadIcon size={18} data-id="element-67" />
                Descargar Excel
              </motion.button>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={clearAllRegistrations} disabled={registrations.length === 0} className="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:bg-gray-700 disabled:cursor-not-allowed rounded-lg font-medium transition-colors" data-id="element-68">
                Limpiar Todo
              </motion.button>
            </div>
          </div>
          {registrations.length === 0 ? <div className="text-center py-12 text-gray-400" data-id="element-69">
              No hay registros todavía
            </div> : <div className="overflow-x-auto" data-id="element-70">
              <table className="w-full" data-id="element-71">
                <thead data-id="element-72">
                  <tr className="border-b border-gray-800" data-id="element-73">
                    <th className="text-left py-3 px-4 text-gray-400 font-medium" data-id="element-74">
                      #
                    </th>
                    <th className="text-left py-3 px-4 text-gray-400 font-medium" data-id="element-75">
                      Nombre
                    </th>
                    <th className="text-left py-3 px-4 text-gray-400 font-medium" data-id="element-76">
                      Email
                    </th>
                    <th className="text-left py-3 px-4 text-gray-400 font-medium" data-id="element-77">
                      Fecha
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-78">
                  {registrations.map((reg, index) => <tr key={reg.id} className="border-b border-gray-800 hover:bg-gray-800/50" data-id="element-79">
                      <td className="py-3 px-4 text-gray-400" data-id="element-80">{index + 1}</td>
                      <td className="py-3 px-4" data-id="element-81">{reg.nombre}</td>
                      <td className="py-3 px-4" data-id="element-82">{reg.email}</td>
                      <td className="py-3 px-4 text-gray-400" data-id="element-83">
                        {new Date(reg.fecha).toLocaleString('es-ES')}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
        </div>
      </motion.div>
    </div>;
};